import { render, staticRenderFns } from "./RipaCitiesGrid.vue?vue&type=template&id=c623e8c4"
import script from "./RipaCitiesGrid.vue?vue&type=script&lang=js"
export * from "./RipaCitiesGrid.vue?vue&type=script&lang=js"
import style0 from "./RipaCitiesGrid.vue?vue&type=style&index=0&id=c623e8c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports